// Contact starts
function toggleSubmitContact() {
  if ($(".ca_contact-checkbox__input").is(":checked")) {
    $(".ca_contact-button__cs").prop("disabled", false);
  } else {
    $(".ca_contact-button__cs").prop("disabled", true);
  }
}

$(document).ready(function () {
  toggleSubmitContact();
  $(document).on("change", ".ca_contact-checkbox__input", function () {
    toggleSubmitContact();
  });
});
// Contact ends



// Colab gallery starts
document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButtonColab = document.querySelector('.ca_colab-button__js');
  const hiddenPhotosColab = document.querySelectorAll('.ca_colab-photo--hidden');
  let itemsToShowColab = 12;
  const incrementColab = 3;
  
  if (loadMoreButtonColab && hiddenPhotosColab.length > 0) {
    loadMoreButtonColab.addEventListener('click', function() {
      const nextItemsColab = Math.min(
        itemsToShowColab + incrementColab,
        hiddenPhotosColab.length + 12
      );
      
      for (let i = itemsToShowColab; i < nextItemsColab; i++) {
        if (hiddenPhotosColab[i - 12]) {
          hiddenPhotosColab[i - 12].classList.remove('ca_colab-photo--hidden');
        }
      }
      
      itemsToShowColab = nextItemsColab;
      
      if (itemsToShowColab >= (hiddenPhotosColab.length + 12)) {
        loadMoreButtonColab.style.display = 'none';
      }
    });
  }
});
// Colab gallery ends



// Main product starts
$(document).on("click", ".ca_product-tab__header", function () {
  let parent = $(this).closest(".ca_product-tab");
  let body = $(this).next();
  if (parent.hasClass("active")) {
    parent.removeClass("active");
    body.slideUp(300);
  } else {
    $(".ca_product-tab").removeClass("active");
    $(".ca_product-tab__body").slideUp(300);
    parent.addClass("active");
    body.slideDown(300);
  }
});
// Main product ends



// Collections list starts
document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButtonColList = document.querySelector('.ca_collections_list-button__js');
  const hiddenPhotosColList = document.querySelectorAll('.ca_collections_list-collection__hidden');
  let itemsToShowColList = 12;
  const incrementColList = 3;
  
  if (loadMoreButtonColList && hiddenPhotosColList.length > 0) {
    loadMoreButtonColList.addEventListener('click', function() {
      const nextItemsColList = Math.min(
        itemsToShowColList + incrementColList,
        hiddenPhotosColList.length + 12
      );
      
      for (let i = itemsToShowColList; i < nextItemsColList; i++) {
        if (hiddenPhotosColList[i - 12]) {
          hiddenPhotosColList[i - 12].classList.remove('ca_collections_list-collection__hidden');
        }
      }
      
      itemsToShowColList = nextItemsColList;
      
      if (itemsToShowColList >= (hiddenPhotosColList.length + 12)) {
        loadMoreButtonColList.style.display = 'none';
      }
    });
  }
});
// Collections list ends



// Form starts
function toggleSubmitButton() {
  if ($(".ca_form-checkbox__input").is(":checked")) {
    $(".ca_form-button__cs").prop("disabled", false);
  } else {
    $(".ca_form-button__cs").prop("disabled", true);
  }
}

$(document).ready(function () {
  toggleSubmitButton();
  $(document).on("change", ".ca_form-checkbox__input", function () {
    toggleSubmitButton();
  });
});
// Form ends



// Multi starts
document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButtonMulti = document.querySelector('.ca_multi-button__js');
  const hiddenPhotosMulti = document.querySelectorAll('.ca_multi-project__hidden');
  let itemsToShowMulti = 3;
  const incrementMulti = 3;
  
  if (loadMoreButtonMulti && hiddenPhotosMulti.length > 0) {
    loadMoreButtonMulti.addEventListener('click', function() {
      const nextItemsMulti = Math.min(
        itemsToShowMulti + incrementMulti,
        hiddenPhotosMulti.length + 3
      );
      
      for (let i = itemsToShowMulti; i < nextItemsMulti; i++) {
        if (hiddenPhotosMulti[i - 3]) {
          hiddenPhotosMulti[i - 3].classList.remove('ca_multi-project__hidden');
        }
      }
      
      itemsToShowMulti = nextItemsMulti;
      
      if (itemsToShowMulti >= (hiddenPhotosMulti.length + 3)) {
        loadMoreButtonMulti.style.display = 'none';
      }
    });
  }
});
// Multi ends



// Announcement bar starts
document.addEventListener('DOMContentLoaded', function () {
  const bar = document.querySelector('.ca_announcement_bar-bg');
  const closeBtn = document.querySelector('.ca_announcement_bar-cross');

  if (!bar || !closeBtn) return;

  const STORAGE_KEY = 'ca_announcement_hidden_until';
  const now = Date.now();
  const hiddenUntil = localStorage.getItem(STORAGE_KEY);

  if (hiddenUntil && now < hiddenUntil) {
    bar.style.display = 'none';
    return;
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }

  closeBtn.addEventListener('click', function () {
    bar.style.display = 'none';
    const threeDays = 3 * 24 * 60 * 60 * 1000;
    const hideUntil = Date.now() + threeDays;

    localStorage.setItem(STORAGE_KEY, hideUntil);
  });
});
// Announcement bar ends



// Quote starts
function toggleSubmitContact() {
  if ($(".ca_form-checkbox__input").is(":checked")) {
    $(".ca_quote-submit").prop("disabled", false);
  } else {
    $(".ca_quote-submit").prop("disabled", true);
  }
}

$(document).ready(function () {
  toggleSubmitContact();  
  $(document).on("change", ".ca_form-checkbox__input", function () {
    toggleSubmitContact();
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const allSections = document.querySelectorAll('.ca_quote-data');
  const totalSections = allSections.length;
  
  const sectionOrder = [
    'ca_quote-home',
    'ca_quote-pricing',
    'ca_quote-rooms',
    'ca_quote-date',
    'ca_quote-identity',
    'ca_quote-info'
  ];
  
  let currentStepIndex = 0;
  
  function showSection(sectionClass) {
    allSections.forEach(function(section) {
      section.style.display = 'none';
    });
    
    const targetSection = document.querySelector('.' + sectionClass);
    if (targetSection) {
      targetSection.style.display = 'block';
    }
    
    updateProgressBar(sectionClass);
  }
  
  function updateProgressBar(currentSectionClass) {
    const progressBar = document.querySelector('.ca_quote-progress');
    if (!progressBar) return;
    
    const currentIndex = sectionOrder.indexOf(currentSectionClass);
    if (currentIndex !== -1) {
      const percentage = ((currentIndex + 1) / totalSections) * 100;
      progressBar.style.width = percentage + '%';
      progressBar.setAttribute('data-percentage', Math.round(percentage));
      
      const progressText = document.querySelector('.ca_quote-progress-text');
      if (progressText) {
        progressText.textContent = Math.round(percentage) + '%';
      }
    }
  }
  
  function goToNextSection(currentSectionClass) {
    const currentIndex = sectionOrder.indexOf(currentSectionClass);
    if (currentIndex !== -1 && currentIndex < totalSections - 1) {
      const nextSection = sectionOrder[currentIndex + 1];
      showSection(nextSection);
    }
  }
  
  function goToPreviousSection(currentSectionClass) {
    const currentIndex = sectionOrder.indexOf(currentSectionClass);
    if (currentIndex > 0) {
      const prevSection = sectionOrder[currentIndex - 1];
      showSection(prevSection);
    }
  }
  
  const homeRadios = document.querySelectorAll('.ca_quote-radios__home .ca_quote-radio__input');
  homeRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (this.checked) {
        goToNextSection('ca_quote-home');
      }
    });
  });
  
  const pricingRadios = document.querySelectorAll('.ca_quote-radios__pricing .ca_quote-radio__input');
  pricingRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (this.checked) {
        goToNextSection('ca_quote-pricing');
      }
    });
  });
  
  const pricingBackButton = document.querySelector('.ca_quote-back__pricing');
  if (pricingBackButton) {
    pricingBackButton.addEventListener('click', function() {
      showSection('ca_quote-home');
    });
  }
  
  const roomsForwardButton = document.querySelector('.ca_quote-forward__rooms');
  if (roomsForwardButton) {
    roomsForwardButton.addEventListener('click', function() {
      const roomCheckboxes = document.querySelectorAll('.ca_quote-checkboxes__rooms .ca_quote-checkbox__input');
      let hasChecked = false;
      roomCheckboxes.forEach(function(checkbox) {
        if (checkbox.checked) hasChecked = true;
      });
      
      if (hasChecked) {
        goToNextSection('ca_quote-rooms');
      } else {
        alert('Please select at least one room to stage.');
      }
    });
  }
  
  const roomsBackButton = document.querySelector('.ca_quote-back__rooms');
  if (roomsBackButton) {
    roomsBackButton.addEventListener('click', function() {
      showSection('ca_quote-pricing');
    });
  }
  
  const dateForwardButton = document.querySelector('.ca_quote-forward__date');
  if (dateForwardButton) {
    dateForwardButton.addEventListener('click', function() {
      const dateInput = document.querySelector('#quote-date');
      if (dateInput && dateInput.value) {
        goToNextSection('ca_quote-date');
      } else {
        alert('Please select a date for when you plan to go on market.');
      }
    });
  }
  
  const dateBackButton = document.querySelector('.ca_quote-back__date');
  if (dateBackButton) {
    dateBackButton.addEventListener('click', function() {
      showSection('ca_quote-rooms');
    });
  }
  
  const identityRadios = document.querySelectorAll('.ca_quote-radios__identity .ca_quote-radio__input');
  identityRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (this.checked) {
        goToNextSection('ca_quote-identity');
      }
    });
  });
  
  const identityBackButton = document.querySelector('.ca_quote-back__identity');
  if (identityBackButton) {
    identityBackButton.addEventListener('click', function() {
      showSection('ca_quote-date');
    });
  }
  
  const infoBackButtons = document.querySelectorAll('.ca_quote-info .ca_quote-back__rooms');
  infoBackButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      showSection('ca_quote-identity');
    });
  });
  
  showSection('ca_quote-home');
});


document.addEventListener('DOMContentLoaded', function() {
  const quoteSubmitBtn = document.querySelector('.ca_quote-submit');
  
  if (quoteSubmitBtn) {
    quoteSubmitBtn.disabled = false;
    
    quoteSubmitBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const loaderText = this.querySelector('.loader-button__text');
      const loaderSpinner = this.querySelector('.loader-button__loader');
      if (loaderText) loaderText.style.opacity = '0';
      if (loaderSpinner) loaderSpinner.hidden = false;
      
      const homeValue = document.querySelector('input[name="contact[home_florida]"]:checked')?.value || '';
      const pricingValue = document.querySelector('input[name="contact[pricing]"]:checked')?.value || '';
      const roomsSelected = Array.from(document.querySelectorAll('input[name="contact[rooms][]"]:checked')).map(cb => cb.value).join(', ');
      const dateValue = document.querySelector('input[name="contact[market_date]"]')?.value || '';
      const identityValue = document.querySelector('input[name="contact[identity]"]:checked')?.value || '';
      const nameValue = document.querySelector('input[name="contact[name]"]')?.value || '';
      const companyValue = document.querySelector('input[name="contact[company]"]')?.value || '';
      const emailValue = document.querySelector('input[name="contact[email]"]')?.value || '';
      const phoneValue = document.querySelector('input[name="contact[phone]"]')?.value || '';
      const consentValue = document.querySelector('input[name="contact[consent]"]')?.checked || false;
      
      const targetHome = document.querySelector('input[name="target_home"]');
      const targetPricing = document.querySelector('input[name="target_pricing"]');
      const targetRooms = document.querySelector('input[name="target_rooms"]');
      const targetDate = document.querySelector('input[name="target_date"]');
      const targetIdentity = document.querySelector('input[name="target_identity"]');
      const targetName = document.querySelector('input[name="target_name"]');
      const targetCompany = document.querySelector('input[name="target_company"]');
      const targetEmail = document.querySelector('input[name="target_email"]');
      const targetPhone = document.querySelector('input[name="target_phone"]');
      
      if (targetHome) targetHome.value = homeValue;
      if (targetPricing) targetPricing.value = pricingValue;
      if (targetRooms) targetRooms.value = roomsSelected;
      if (targetDate) targetDate.value = dateValue;
      if (targetIdentity) targetIdentity.value = identityValue;
      if (targetName) targetName.value = nameValue;
      if (targetCompany) targetCompany.value = companyValue;
      if (targetEmail) targetEmail.value = emailValue;
      if (targetPhone) targetPhone.value = phoneValue;
      
      const mainForm = document.getElementById('ca-quote-form');
      const appForm = document.querySelector('.pmyf-elements-container').closest('form');
      
      if (appForm) {
        const appSubmitBtn = document.querySelector('.target-submit button');
        if (appSubmitBtn) {
          appSubmitBtn.click();
        }
      }
      
      setTimeout(() => {
        if (mainForm) {
          mainForm.submit();
        }
      }, 50);
    });
  }
});
// Quote ends



// Image text starts
document.addEventListener('DOMContentLoaded', function() {
  const atcButtons = document.querySelectorAll('.ca_image_text-atc__button');
  
  atcButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const variantId = this.dataset.productId;
      const textSpan = this.querySelector('.ca_image_text-atc__text');
      const loaderSpan = this.querySelector('.ca_image_text-atc__loader');
      
      if (!variantId) return;
      
      if (textSpan) textSpan.classList.add('ca_image_text-atc__text-hidden');
      if (loaderSpan) loaderSpan.classList.remove('ca_image_text-atc__loader-hidden');
      
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1
            }]
          })
        });
        
        if (addResponse.ok) {
          const cartUrl = window.themeVariables?.routes?.cartUrl || '/cart';
          const sectionResponse = await fetch(`${cartUrl}?section_id=mini-cart`);
          const html = await sectionResponse.text();
          
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newCartDrawer = tempDiv.querySelector('cart-drawer');
          
          if (newCartDrawer) {
            const existingCartDrawer = document.querySelector('cart-drawer');
            
            if (existingCartDrawer) {
              existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
              
              existingCartDrawer.setAttribute('open', '');
              
              window.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: {
                  openMiniCart: true
                }
              }));
            }
          }
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setTimeout(() => {
          if (textSpan) textSpan.classList.remove('ca_image_text-atc__text-hidden');
          if (loaderSpan) loaderSpan.classList.add('ca_image_text-atc__loader-hidden');
        }, 300);
      }
    });
  });
});
// Image text ends
